import api from '@/services/api';

/**
 * Lädt Meldungen (standardmäßig nur letztes Kind je Thread).
 * Optional können Query-Parameter übergeben werden (z. B. { parent_user_id: 123 }).
 */
export async function fetchNotifications(params = {}) {
  const res = await api.get('/notifications', { params });
  return res.data;
}

/**
 * Löscht (soft-delete) eine Meldung.
 */
export async function deleteNotification(id) {
    const res = await api.delete(`/notifications/${encodeURIComponent(id)}`);
    return res?.data ?? null;
}

/**
 * Lädt die pro Schüler jüngste Meldung für einen Schultag (Europe/Berlin).
 * params: { day?: 'YYYY-MM-DD' } – wenn nicht gesetzt, liefert das Backend den nächsten Schultag.
 * Rückgabe: Objekt { day, data }.
 */
export async function fetchNotificationsForDay(params = {}) {
  const res = await api.get('/notifications/follow-day', { params });
  const payload = res?.data ?? {};
  const day = typeof payload?.day === 'string' ? payload.day : null;
  const list = Array.isArray(payload?.data) ? payload.data : (Array.isArray(payload) ? payload : []);
  const groups = Array.isArray(payload?.groups) ? payload.groups : [];
  return { day, data: list, groups };
}

/**
 * Aktualisiert den Status einer Meldung.
 */
export async function updateNotificationStatus(id, status) {
  const res = await api.post(`/notifications/${encodeURIComponent(id)}/status`, { status });
  return res.data;
}

/**
 * Lädt den Anhang zu einer Meldung.
 * Gibt die Axios-Response (Blob) zurück.
 */
export async function downloadAttachment(id) {
  return api.get(`/notifications/${encodeURIComponent(id)}/attachment`, {
    responseType: 'blob',
  });
}

/**
 * Chat: Nachrichten eines Threads (durch Meldungs-ID) laden.
 */
export async function fetchNotificationChat(id) {
  const res = await api.get(`/notifications/${encodeURIComponent(id)}/chat`);
  // Erwartet Array
  return Array.isArray(res?.data) ? res.data : (Array.isArray(res?.data?.data) ? res.data.data : []);
}

/**
 * Chat: Nachricht senden.
 */
export async function postNotificationChatMessage(id, message) {
  const res = await api.post(`/notifications/${encodeURIComponent(id)}/chat`, { message });
  return res?.data ?? null;
}

/**
 * Chat: Thread für aktuellen Benutzer als gelesen markieren.
 */
export async function markNotificationChatRead(id) {
  await api.post(`/notifications/${encodeURIComponent(id)}/chat/read`, {});
  return true;
}

/**
 * Unread-Map: Liefert ein Objekt { [threadId]: count } für den aktuellen Benutzer.
 */
export async function fetchNotificationsUnreadMap() {
  const res = await api.get('/notifications/unread-map');
  // Rückgabe robust mappen
  const data = res?.data ?? {};
  return data && typeof data === 'object' ? data : {};
}

/** Gemeinsame Nachrichten-Inbox für Admins und Lehrkräfte. */
export async function fetchNotificationMessageThreads() {
  const res = await api.get('/notifications/messages');
  return Array.isArray(res?.data) ? res.data : [];
}

/** Markiert die jüngste Elternnachricht für die gemeinsame Staff-Inbox als ungelesen. */
export async function markNotificationChatUnread(id) {
  await api.post(`/notifications/${encodeURIComponent(id)}/chat/unread`, {});
  return true;
}
